import z from 'zod';

export const FanforgeServerJwtClaimsPlatformSchema = z.object({
  iss: z.string(), // issuer
  aud: z.string(), // audience
  sub: z.string(), // subject
  platform: z.enum(['web', 'discord']),
  username: z.string(), // username of the user
  display_name: z.string().nullable(), // display name of the user, can be null
  guild_id: z.string().nullable(),
  iat: z.number().optional(), // issued at
  exp: z.number().optional(), // expires at
});

export type FanforgeServerJwtClaimsPlatform = z.infer<typeof FanforgeServerJwtClaimsPlatformSchema>;
